module.exports = __webpack_public_path__ + "static/semantic-select-multiple-15601db1ee92e2c7bf7e8c7138340cd8.png";